var drawer = function () {
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }
      Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (ancestor.matches(s)) return ancestor;
          ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
      };
    }

    var settings = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',

    };

    var toggleccessibility = function (event) {
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };

    var openDrawer = function (trigger) {
      var target = document.getElementById(trigger.getAttribute('aria-controls'));
      target.classList.add(settings.activeClass);
      document.body.style.overflow = 'hidden';
      toggleccessibility(trigger);


      setTimeout(function () {
        target.classList.add(settings.visibleClass);
      }, settings.speedOpen);

      if (document.getElementById("shopify-section-announcement-bar")) {
        document.getElementById("shopify-section-announcement-bar").classList.add("stickymodal")
        document.getElementById("shopify-section-header").classList.add("stickymodal")
        document.getElementById("shopify-section-poloclub-header").classList.add("stickymodal")
      }

      function counterAnimationHandler() {
        // Selector
        const counters = document.querySelectorAll('.cart__sustainability eco-rating');
        // Main function
        counters.forEach(counter => {
          counter.innerText = "0";
          const target = parseFloat(counter.getAttribute('data-eco')) //define increase couter to it's data-target
          var count = 0 //define increase couter on innerText
          
          if (target < 0.08) {
            var increment = target; 
          } else if (target < 0.15) {
            var increment = target/12.5;  
          } else if (target < 0.30) {
            var increment = target/25;
          } else if (target < 0.50) {
            var increment = target/50;
          } else {
            var increment = target/100;
          }

          var itvl = setInterval(function() {
            update(count)
            count+=increment
            count = parseFloat(count.toFixed(2));
            if (count >= target) {
              clearInterval(itvl);
              var exactTarget = counter.getAttribute('data-eco');
              update(exactTarget);
            }
          }, 20)

          function update(count) {
            counter.innerText = count;
          }
          function update(exactTarget) {
            counter.innerText = exactTarget;
          }
        })
      }
      counterAnimationHandler();
    };

    var closeDrawer = function (event) {
      var closestParent = event.closest(settings.selectorTarget),
      childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
      closestParent.classList.remove(settings.visibleClass);
      document.body.style.overflow = '';
      toggleccessibility(childrenTrigger);
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass);
      }, settings.speedClose);
      if (document.getElementById("shopify-section-announcement-bar")) {
        document.getElementById("shopify-section-announcement-bar").classList.remove("stickymodal")
        if (document.querySelector("#shopify-section-header")) {
          document.getElementById("shopify-section-header").classList.remove("stickymodal")
        }
        if (document.querySelector("#shopify-section-poloclub-header")) {
          document.getElementById("shopify-section-poloclub-header").classList.remove("stickymodal")
        }
      }
    };
    var clickHandler = function (event) {
      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose);


      if (close) { closeDrawer(close); }
      if (open) { openDrawer(open); }
      if (open || close) { event.preventDefault(); }
    };


    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i;
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeDrawer(drawers[i]);
          }
        }
      }
    };

    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);
};

drawer();